import { render, staticRenderFns } from "./List-aviso.vue?vue&type=template&id=621760fa&scoped=true&"
import script from "./List-aviso.vue?vue&type=script&lang=js&"
export * from "./List-aviso.vue?vue&type=script&lang=js&"
import style0 from "./List-aviso.vue?vue&type=style&index=0&id=621760fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621760fa",
  null
  
)

export default component.exports